<template>
  <div class="security-report-preview">
    <!-- 报告内容区域 -->
    <div id="printContentSecurity" class="report-content">
      <!-- 第1页：封面信息 -->
      <div class="page page-1">
        <img :src="dwImage" class="watermark" alt="">
        <img :src="dw1Image" class="watermark-center" alt="">
        <div class="cover-content">
          <div class="header-row">
            <div v-if="showStamp" class="header-left">
              <!-- MA 图标已移除，保留同尺寸占位(80x40+右边距10)保持原版面 -->
              <div style="width: 80px; height: 40px; margin-right: 10px; flex-shrink: 0;" />
              <img :src="require('@/assets/sh.png')" alt="sh" class="header-sh">
            </div>
            <div v-if="showStamp" class="header-right">
              <div class="qrcode-report-id">报告编号: {{ data.report_number }}</div>
              <div v-html="qrCode" />
              <div class="qrcode-label">扫码查验</div>
            </div>
          </div>

          <div class="spacer" />
          <div class="spacer" />
          <div class="spacer" />

          <div class="main-title">
            <h1>检 验 报 告</h1>
            <p class="subtitle">Inspection Report</p>
          </div>

          <div class="spacer" />
          <div class="spacer" />

          <div class="section-title">
            <p>{{ data.report_name || '自定义部分' }}</p>
          </div>

          <div class="spacer" />
          <div class="spacer" />
          <div class="spacer" />
          <div class="spacer" />

          <div class="info-section">
            <div class="info-row">
              <div class="info-label">
                <span class="label">设备名称</span>
                <span class="label-en">Equipment Name</span>
              </div>
              <div class="info-line"><span class="info-value">{{ data.equipment_name || '/' }}</span></div>
            </div>

            <div class="spacer-sm" />

            <div class="info-row">
              <div class="info-label">
                <span class="label">设备号牌</span>
                <span class="label-en">Equipment Nameplate</span>
              </div>
              <div class="info-line"><span class="info-value">{{ data.equipment_number || '/' }}</span></div>
            </div>

            <div class="spacer-sm" />

            <div class="info-row">
              <div class="info-label">
                <span class="label">委托单位</span>
                <span class="label-en">Client</span>
              </div>
              <div class="info-line"><span class="info-value">{{ data.client || '/' }}</span></div>
            </div>

            <div class="spacer-sm" />

            <div class="info-row">
              <div class="info-label">
                <span class="label">检验日期</span>
                <span class="label-en">Inspection Date</span>
              </div>
              <div class="info-line"><span class="info-value">{{ formatDate(data.inspection_date) }}</span></div>
            </div>
          </div>

          <div class="spacer" />
          <div class="spacer" />
          <div class="spacer" />
          <div class="spacer" />
          <div class="spacer" />

          <div class="footer">
            <div class="company-name">安徽申环检测认证有限公司</div>
            <div class="company-name-en">ANHUI SHENHUAN TESTING CERTIFICATION CO., LTD.</div>
          </div>
        </div>
      </div>

      <!-- 第2页：注意事项 -->
      <div class="page page-2">
        <img :src="dwImage" class="watermark" alt="">
        <img :src="dw1Image" class="watermark-center" alt="">
        <div class="page-header">
          <h2>注意事项</h2>
        </div>

        <div class="precautions-list">
          <div class="item">
            <span class="number">一、</span>
            <span class="content">除全文复制外，未经本单位批准不得部分复制报告。</span>
          </div>
          <div class="item">
            <span class="number">二、</span>
            <span class="content">本报告书应由计算机打印或钢笔填写，涂改无效。</span>
          </div>
          <div class="item">
            <span class="number">三、</span>
            <span class="content">本报告书一式二份。由检测机构、委托检测单位保存。</span>
          </div>
          <div class="item">
            <span class="number">四、</span>
            <span class="content">本报告书无检测、审核、批准人员签字和检测机构的检测专用章无效。</span>
          </div>
          <div class="item">
            <span class="number">五、</span>
            <span class="content">受检单位对检测结论如有异议，应在收到报告之日起7个工作日内，以书面形式向检测机构提出。</span>
          </div>
          <div class="item">
            <span class="number">六、</span>
            <span class="content">本报告只对检测时的工程机械状况负责。</span>
          </div>
          <div class="item">
            <span class="number">七、</span>
            <span class="content">检测机构地址：合肥市经开区芙蓉路642号天润大厦1703。</span>
          </div>
          <div class="phone-line">
            <span>电话：0551-62857172</span>
          </div>
        </div>

        <div class="precautions-en-list">
          <div class="precautions-en-header">
            <h3 class="text-center">Precautions</h3>
          </div>
          <div class="item">
            <span class="number">1.</span>
            <span class="content">This report shall not be reproduced, in whole or in part, without the prior written approval of this organization.</span>
          </div>
          <div class="item">
            <span class="number">2.</span>
            <span class="content">This report must be computer-generated or completed in ink. Any alterations or amendments shall render the report invalid.</span>
          </div>
          <div class="item">
            <span class="number">3.</span>
            <span class="content">This report is issued in two (2) originals, one to be retained by the inspection organization and the other by the commissioning entity.</span>
          </div>
          <div class="item">
            <span class="number">4.</span>
            <span class="content">This report shall be deemed invalid without the signatures of the inspection personnel, reviewer, and approver, and without the official seal of the inspection organization.</span>
          </div>
          <div class="item">
            <span class="number">5.</span>
            <span class="content">Should the inspected entity have any objections to the inspection conclusions, a written appeal shall be submitted to the inspection organization within seven (7) working days from the date of receipt of this report.</span>
          </div>
          <div class="item">
            <span class="number">6.</span>
            <span class="content">This report is valid only for the condition of the construction machinery at the time of inspection.</span>
          </div>
          <div class="item address-item">
            <span class="number">7.</span>
            <span class="content">Address of the Inspection Organization: Room 1703, Tianrun Building, No. 642 Furong Road, Economic and Technological Development Zone, Hefei, China. Tel: 0551-62857172</span>
          </div>
        </div>
      </div>

      <!-- 第3页：检验结论 -->
      <div class="page page-3">
        <img :src="dwImage" class="watermark" alt="">
        <img :src="dw1Image" class="watermark-center" alt="">
        <div class="page-header">
          <h2>检验报告结论页</h2>
          <div class="report-info">
            <span>报告编号：{{ data.report_number || '/' }}</span>
            <span>共 4 页 第 1 页</span>
          </div>
        </div>

        <table class="report-table">
          <tbody>
            <tr>
              <td class="label-col" colspan="2">委托单位</td>
              <td class="value-col" colspan="5">{{ data.client || '/' }}</td>
            </tr>
            <tr>
              <td class="label-col" colspan="2">制造单位</td>
              <td class="value-col" colspan="5">{{ data.manufacturing_unit || '/' }}</td>
            </tr>
            <tr>
              <td class="label-col" colspan="2">设备号牌</td>
              <td class="value-col">{{ data.equipment_number || '/' }}</td>
              <td class="label-col" colspan="3">设备型号</td>
              <td class="value-col">{{ data.equipment_model || '/' }}</td>
            </tr>
            <tr>
              <td class="label-col" colspan="2">设备颜色</td>
              <td class="value-col">{{ data.equipment_color || '/' }}</td>
              <td class="label-col" colspan="3">燃料种类</td>
              <td class="value-col">{{ data.fuel_type || '/' }}</td>
            </tr>
            <tr>
              <td class="label-col" colspan="2">车架号/VIN</td>
              <td class="value-col">{{ data.chassis_number || '/' }}</td>
              <td class="label-col" colspan="3">发动机号/电机号</td>
              <td class="value-col">{{ data.engine_number || '/' }}</td>
            </tr>
            <tr>
              <td class="label-col" colspan="2">出厂日期</td>
              <td class="value-col">{{ formatDate(data.manufacture_date) }}</td>
              <td class="label-col" colspan="3">检测时间</td>
              <td class="value-col">{{ formatDate(data.inspection_date) }}</td>
            </tr>
            <tr>
              <td class="label-col" colspan="2">检测地点</td>
              <td class="value-col" colspan="5">{{ getFullInspectionLocation() }}</td>
            </tr>
            <tr>
              <td class="standards-header" colspan="7">
                <strong>检测依据：</strong>
                <div class="standards-content">
                  <div v-for="(standard, index) in data.testing_standards" :key="index" class="standard-item">
                    {{ String.fromCharCode(97 + index) }}) {{ standard }}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="equipment-header" colspan="7">
                <strong>检测仪器设备及需要检测环境说明：</strong>
              </td>
            </tr>
            <tr>
              <td class="header-cell col-seq">序号</td>
              <td class="header-cell col-name" colspan="3">检测设备名称</td>
              <td class="header-cell col-model">型号规格</td>
              <td class="header-cell col-date" colspan="2">计量有效期</td>
            </tr>
            <tr v-for="(equipment, index) in data.testing_equipment" :key="index">
              <td class="center-cell col-seq">{{ index + 1 }}</td>
              <td class="value-cell col-name" colspan="3">{{ equipment.name || '/' }}</td>
              <td class="center-cell col-model">{{ equipment.model || '/' }}</td>
              <td class="center-cell col-date" colspan="2">{{ formatDate(equipment.calibration_date) }}</td>
            </tr>
            <tr>
              <td class="result-label" colspan="2">
                <strong>检测结论</strong>
              </td>
              <td class="result-content" colspan="5">
                <p class="result-text">
                  所检测项目符合相应标准要求，检验<strong class="result-highlight">{{ data.inspection_result || '合格' }}</strong>。
                </p>
                <div class="result-footer">
                  <div class="stamp-wrapper">
                    <img v-if="showStamp" :src="require('@/assets/gz.png')" alt="盖章" class="stamp-image">
                    <div class="stamp-placeholder">（检测机构盖章）</div>
                  </div>
                  <div class="report-date">报告日期：{{ formatDate(data.approval_date) }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="label-col" colspan="2">备注</td>
              <td class="value-col" colspan="5">有效期为 {{ data.validity_period || '一年' }}</td>
            </tr>
          </tbody>
        </table>

        <div class="signatures">
          <div style="float: left; height: 45px; line-height: 45px;">检验：</div>
          <div style="float: left; margin-top: 5px; width: 100px; margin-left: -20px;"><img v-if="data.inspector_sign" :src="baseURL + data.inspector_sign" style="width: 100px;" alt=""></div>
          <div style="float: left; height: 45px; line-height: 45px; margin-left: 20px;">审核：</div>
          <div style="float: left; margin-top: 5px; width: 100px; margin-left: -20px;"><img v-if="data.reviewer_sign" :src="baseURL + data.reviewer_sign" style="width: 100px;" alt=""></div>
          <div style="float: left; height: 45px; line-height: 45px; margin-left: 20px;">批准：</div>
          <div style="float: left; margin-top: 5px; width: 100px; margin-left: -20px;"><img v-if="data.approver_sign" :src="baseURL + data.approver_sign" style="width: 100px;" alt=""></div>
        </div>
      </div>

      <!-- 第4页：检测项目表1 -->
      <div class="page page-4">
        <img :src="dwImage" class="watermark" alt="">
        <img :src="dw1Image" class="watermark-center" alt="">
        <div class="page-header">
          <h2>检验报告附页</h2>
          <div class="report-info">
            <span>报告编号：{{ data.report_number || '/' }}</span>
            <span>共 4 页 第 2 页</span>
          </div>
        </div>

        <table class="check-table">
          <thead>
            <tr>
              <th class="col-project">检验项目</th>
              <th class="col-num">序号</th>
              <th class="col-requirement">标准要求</th>
              <th class="col-result">检验结果</th>
              <th class="col-judgment">单项判定</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in inspectionTablePage1" :key="'row-' + index">
              <td v-if="getRowSpan(index, inspectionTablePage1) > 0" class="col-project" :rowspan="getRowSpan(index, inspectionTablePage1)">{{ item.title }}</td>
              <td class="col-num">{{ item.code }}</td>
              <td class="col-requirement">{{ item.requirement }}</td>
              <td class="col-result">{{ item.result }}</td>
              <td v-if="getRowSpan(index, inspectionTablePage1) > 0" class="col-judgment" :rowspan="getRowSpan(index, inspectionTablePage1)">{{ item.judgment }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 第5页：检测项目表2 -->
      <div class="page page-5">
        <img :src="dwImage" class="watermark" alt="">
        <img :src="dw1Image" class="watermark-center" alt="">
        <div class="page-header">
          <h2>检验报告附页</h2>
          <div class="report-info">
            <span>报告编号：{{ data.report_number || '/' }}</span>
            <span>共 4 页 第 3 页</span>
          </div>
        </div>

        <table class="check-table">
          <thead>
            <tr>
              <th class="col-project">检验项目</th>
              <th class="col-num">序号</th>
              <th class="col-requirement">标准要求</th>
              <th class="col-result">检验结果</th>
              <th class="col-judgment">单项判定</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in inspectionTablePage2" :key="'row2-' + index">
              <td v-if="getRowSpan(index, inspectionTablePage2) > 0" class="col-project" :rowspan="getRowSpan(index, inspectionTablePage2)">{{ item.title }}</td>
              <td class="col-num">{{ item.code }}</td>
              <td class="col-requirement">{{ item.requirement }}</td>
              <td class="col-result">{{ item.result }}</td>
              <td v-if="getRowSpan(index, inspectionTablePage2) > 0" class="col-judgment" :rowspan="getRowSpan(index, inspectionTablePage2)">{{ item.judgment }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 第6页：照片页 -->
      <div class="page page-6">
        <img :src="dwImage" class="watermark" alt="">
        <img :src="dw1Image" class="watermark-center" alt="">
        <div class="page-header">
          <h2>检验报告附页</h2>
          <div class="report-info">
            <span>报告编号：{{ data.report_number || '/' }}</span>
            <span>共 4 页 第 4 页</span>
          </div>
        </div>

        <table class="photo-table">
          <tr>
            <td class="photo-title">照片</td>
          </tr>
          <tr>
            <td class="photo-content">
              <span class="photo-label">外观照片</span>
              <img v-if="data.appearance_photo_url" :src="data.appearance_photo_url" alt="外观照片">
              <div v-else class="photo-placeholder">设备外观照片</div>
            </td>
          </tr>
          <tr>
            <td class="photo-content">
              <span class="photo-label">铭牌</span>
              <img v-if="data.nameplate_photo_url" :src="data.nameplate_photo_url" alt="铭牌照片">
              <div v-else class="photo-placeholder">设备铭牌照片</div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 审核记录 -->
    <el-row v-if="!showStamp && data.approved_memo && data.approved_memo.length > 0" style="margin-top: 20px;">
      <el-col :span="24" class="center-content">
        <el-table :data="data.approved_memo" style="width: 100%">
          <el-table-column label="角色">
            <template slot-scope="scope">
              <span v-if="scope.row.role === 1">检测员</span>
              <span v-if="scope.row.role === 2">审核员</span>
              <span v-if="scope.row.role === 3">批准员</span>
            </template>
          </el-table-column>
          <el-table-column label="审核结果" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.result === 1">通过</span>
              <span v-if="scope.row.result === 2">不通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="审核时间" />
          <el-table-column prop="user_sign" label="签名" width="100">
            <template slot-scope="scope">
              <img v-if="scope.row.user_sign" :src="baseURL + scope.row.user_sign" alt="" style="width: 100px;">
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <!-- 审核表单 -->
    <div v-if="!showStamp" style="height: 50px;" />
    <div v-if="!showStamp" class="form-center">
      <el-form ref="form" :model="securityForm" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="审核结果" prop="result">
              <el-radio-group v-model="securityForm.result">
                <el-radio label="1">通过</el-radio>
                <el-radio label="2">不通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="签名">
              <div v-if="!resultImg">
                <vue-esign ref="esign" :width="800" :height="300" :is-crop="isCrop" :line-width="lineWidth" :line-color="lineColor" :bg-color.sync="bgColor" style="border: 1px solid #CCCCCC" />
                <button class="sign-btn" type="button" @click="handleReset">清空画板</button>
                <button class="sign-btn" type="button" @click="handleGenerate">确认签名</button>
              </div>
              <img v-if="resultImg" :src="resultImg" alt="" style="width: 30%; height: 30%; margin-top: 10px;">
              <el-button v-if="resultImg" @click="handleResetSign">重新签名</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 提交按钮 -->
    <div v-if="!showStamp" style="text-align: center;">
      <el-button type="primary" @click="submit">{{ actionType === 'approve' ? '确认批准' : '确认审核' }}</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import vueEsign from 'vue-esign'
import { detail } from '@/api/security'
import { getToken } from '@/utils/auth'
import { uploadBase64 } from '@/api/common'

export default {
  name: 'PreviewSecurity',
  components: {
    vueEsign
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showStamp: {
      type: Boolean,
      default: false
    },
    actionType: {
      type: String,
      default: 'review'
    }
  },
  data() {
    return {
      id: 0,
      data: {},
      baseURL: process.env.VUE_APP_BASE_URL,
      qrCode: '',
      dwImage: require('@/assets/dw.png'),
      dw1Image: require('@/assets/dw1.png'),
      securityForm: {
        result: '',
        user_sign: ''
      },
      rules: {
        result: [{ required: true, message: '请选择审核结果', trigger: 'change' }]
      },
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false
    }
  },
  computed: {
    inspectionTableData() {
      const items = this.data.inspection_items || {}
      const result = []

      const sections = [
        { key: 'vehicle_identification', title: '1. 车辆的认定' },
        { key: 'cab_inspection', title: '2. 驾驶室' },
        { key: 'engine_inspection', title: '3. 发动机' },
        { key: 'transmission_inspection', title: '4. 传动系统' },
        { key: 'driving_system_inspection', title: '5. 行驶系统' },
        { key: 'instrument_inspection', title: '6. 仪表' },
        { key: 'electrical_inspection', title: '7. 电气' },
        { key: 'hydraulic_system_inspection', title: '8. 液压系统' }
      ]

      sections.forEach(section => {
        const sectionData = items[section.key]
        if (sectionData && sectionData.items) {
          sectionData.items.forEach((item, index) => {
            result.push({
              title: section.title,
              code: item.code,
              requirement: item.requirement,
              result: item.result || '/',
              judgment: index === 0 ? (sectionData.judgment || '/') : null,
              isFirst: index === 0,
              rowSpan: index === 0 ? sectionData.items.length : 0
            })
          })
        }
      })

      return result
    },
    inspectionTablePage1() {
      return this.inspectionTableData.slice(0, 21)
    },
    inspectionTablePage2() {
      return this.inspectionTableData.slice(21)
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true) {
          this.id = val.id
          this.fetchData(val.id)
        }
      },
      deep: true
    }
  },
  created() {
    const id = this.item.id
    if (id) {
      this.id = id
      this.fetchData(id)
    }
    if (this.$refs.form) {
      this.$refs.form.resetFields()
    }
  },
  methods: {
    shouldShowTitle(index, data) {
      if (index === 0) return true
      return data[index].title !== data[index - 1].title
    },
    shouldShowJudgment(index, data) {
      if (index === 0) return true
      return data[index].title !== data[index - 1].title
    },
    getRowSpan(index, data) {
      if (data[index].rowSpan === 0) return 0
      return data[index].rowSpan
    },
    fetchData(id) {
      detail(id).then(response => {
        this.data = response.data || {}
        // 空值处理为 '/'
        for (const key in this.data) {
          if (this.data[key] === null) {
            this.data[key] = '/'
          }
        }
        // 处理照片URL
        if (this.data.appearance_photo_url) {
          this.data.appearance_photo_url = process.env.VUE_APP_BASE_URL + '/' + this.data.appearance_photo_url
        }
        if (this.data.nameplate_photo_url) {
          this.data.nameplate_photo_url = process.env.VUE_APP_BASE_URL + '/' + this.data.nameplate_photo_url
        }
        // 获取二维码
        if (this.data.uuid) {
          this.fetchQRCode()
        }
      })
    },
    fetchQRCode() {
      const url = process.env.VUE_APP_API + '/common/qrcode' + '?text=' + this.data.uuid
      axios.get(url, {
        headers: {
          'Authorization': 'Bearer ' + getToken()
        }
      }).then(response => {
        this.qrCode = response.data
      }).catch(error => {
        console.error('Error fetching QR code:', error)
      })
    },
    formatDate(date) {
      if (!date) return '/'
      const d = new Date(date)
      return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
    },
    getFullInspectionLocation() {
      if (!this.data) return '/'
      return (this.data.inspection_location_province || '') +
             (this.data.inspection_location_city || '') +
             (this.data.inspection_location_address || '')
    },
    handleReset() {
      this.$refs.esign.reset()
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        this.resultImg = res
        uploadBase64({
          file: res
        }).then(response => {
          this.securityForm.user_sign = response.data.path
        })
      }).catch(err => {
        alert(err)
      })
    },
    handleResetSign() {
      this.resultImg = ''
      this.$refs.esign.reset()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.securityForm.user_sign) {
            this.$message.error('请签名')
            return
          }
          const params = {
            id: this.id,
            result: this.securityForm.result,
            user_sign: this.securityForm.user_sign
          }
          this.$emit('success', params)
        }
      })
    }
  }
}
</script>

<style scoped>
.security-report-preview {
  font-family: 'SimSun', serif;
  font-size: 14px;
  line-height: 1.6;
}

.watermark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 0;
}

.watermark-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 70%;
  height: auto;
  pointer-events: none;
  z-index: 1;
}

.page {
  width: 210mm;
  min-height: 297mm;
  padding: 10mm 15mm;
  margin: 10px auto;
  background-color: transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  page-break-after: always;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.page-1 {
  text-align: center;
  z-index: 1;
}

.page-1,
.page-2,
.page-3,
.page-4,
.page-5,
.page-6 {
  z-index: 1;
}

.page-1 {
  text-align: center;
  z-index: 1;
}

.cover-content,
.page-header,
.precautions-list,
.precautions-en-list,
.report-table,
.check-table,
.photo-table,
.footer,
.signatures,
.info-section {
  position: relative;
  z-index: 2;
}

.report-content {
  position: relative;
}

.page-1,
.page-2,
.page-3,
.page-4,
.page-5,
.page-6 {
  z-index: 1;
}

.center-content {
  display: flex;
  justify-content: center;
}

.form-center {
  display: flex;
  justify-content: center;
}

.sign-btn {
  padding: 10px 20px;
  margin-right: 10px;
  background-color: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cover-content {
  padding: 15px 30px;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.header-logo {
  width: 80px;
  height: auto;
  margin-right: 10px;
}

.header-sh {
  width: 60px;
  height: auto;
}

.header-left {
  display: flex;
  align-items: flex-start;
  margin-top: 50px;
}

.header-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-label {
  font-size: 13px;
  margin-top: 5px;
}

.qrcode-report-id {
  font-size: 13px;
  margin-bottom: 30px;
}

.ma-mark {
  background-color: #c41f3a;
  color: white;
  padding: 5px 10px;
  font-weight: bold;
  font-size: 14px;
}

.cert-number {
  font-size: 10px;
  margin-top: 5px;
}

.spacer {
  height: 25px;
}

.spacer-sm {
  height: 12px;
}

.main-title {
  text-align: center;
}

.main-title h1 {
  font-family: "SimHei", "Microsoft YaHei", sans-serif;
  font-size: 48px;
  font-weight: bold;
  letter-spacing: 8px;
  margin: 0;
  line-height: 1.5;
}

.subtitle {
  font-family: "Calibri", "Arial", sans-serif;
  font-size: 18px;
  letter-spacing: 1px;
  margin-top: 10px;
  color: #333;
}

.section-title {
  text-align: center;
}

.section-title p {
  font-family: "SimHei", "Microsoft YaHei", sans-serif;
  font-size: 28px;
  font-weight: bold;
  margin: 0;
}

.info-section {
  text-align: left;
  padding-left: 40px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}

.info-label {
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: nowrap;
  min-width: 130px;
}

.label {
  font-family: "SimHei", "Microsoft YaHei", sans-serif;
  font-size: 18px;
  letter-spacing: 2px;
}

.label-en {
  font-family: "Calibri", "Arial", sans-serif;
  font-size: 14px;
}

.info-line {
  flex: 1;
  border-bottom: 1px solid #333;
}

.info-value {
  font-family: "SimHei", "Microsoft YaHei", sans-serif;
  font-size: 18px;
  padding-bottom: 5px;
  display: block;
}

.footer {
  text-align: center;
  margin-top: 60px;
}

.company-name {
  font-family: "SimHei", "Microsoft YaHei", sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 2px;
}

.company-name-en {
  font-family: "Calibri", "Arial", sans-serif;
  font-size: 14px;
  margin-top: 5px;
  letter-spacing: 1px;
}

.page-2 {
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 257mm;
}

.page-2 .precautions-list {
  flex: 1;
}

.page-2 .precautions-en-list {
  margin-top: auto;
}

.page-header {
  text-align: center;
  margin-bottom: 20px;
}

.page-header h2 {
  font-size: 24px;
  margin-bottom: 5px;
}

.page-header .subtitle-en {
  font-size: 14px;
  color: #666;
}

.report-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 10px;
}

.precautions-list {
  text-align: justify;
  line-height: 1.8;
}

.item {
  margin: 12px 0;
}

.number {
  font-weight: bold;
}

.content {
  text-indent: 2em;
}

.phone-line {
  margin-top: 20px;
  padding-left: 2em;
}

.phone-line span {
  font-weight: bold;
}

.text-center {
  text-align: center;
}

.contact-info {
  margin-top: 40px;
  text-align: center;
  font-size: 12px;
}

.precautions-en-list {
  margin-top: 40px;
  text-align: justify;
  font-size: 16px;
}

.precautions-en-header {
  margin-bottom: 15px;
}

.precautions-en-header h3 {
  font-size: 20px;
  font-weight: normal;
  margin: 0;
}

.precautions-en-list .item {
  margin: 12px 0;
  line-height: 1.8;
}

.precautions-en-list .content {
  text-indent: 2em;
}

.address-item {
  margin-top: 20px;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  margin: 15px 0;
  box-shadow: 0 0 0 2px #000;
}

.page-3 {
  height: 257mm;
  display: flex;
  flex-direction: column;
}

.page-3 .page-header {
  flex-shrink: 0;
}

.page-3 .report-table {
  flex: 1;
}

.page-3 .signatures {
  margin-top: auto;
  flex-shrink: 0;
}

.report-table td {
  border: 1px solid #000;
  padding: 8px 10px;
  font-size: 14px;
}

.label-col {
  width: 15%;
  background-color: transparent !important;
  text-align: center;
  font-weight: bold;
}

.value-col {
  width: 35%;
}

.standards-header,
.equipment-header {
  background-color: transparent !important;
  padding: 10px !important;
}

.standards-content {
  margin-top: 10px;
  padding-left: 20px;
}

.standard-item {
  margin: 6px 0;
  line-height: 1.5;
  font-size: 13px;
}

.header-cell {
  background-color: transparent !important;
  text-align: center;
  font-weight: bold;
  padding: 8px !important;
  font-size: 14px;
}

.center-cell {
  text-align: center;
}

.value-cell {
  text-align: left;
  padding-left: 20px !important;
}

.col-seq {
  width: 8%;
  text-align: center;
}

.col-name {
  width: 40%;
}

.col-model {
  width: 25%;
}

.col-date {
  width: 27%;
}

.result-label {
  background-color: transparent !important;
  vertical-align: top;
  padding-top: 15px !important;
  width: 15%;
}

.result-content {
  vertical-align: top;
  padding: 15px 10px !important;
}

.result-text {
  margin: 0 0 15px 0;
  font-size: 16px;
  line-height: 1.8;
}

.result-footer {
  margin-top: 20px;
  float: right;
  margin-right: 100px;
  text-align: right;
}

.result-highlight {
  font-size: 28px;
  font-weight: bold;
}

.stamp-wrapper {
  position: relative;
  display: inline-block;
}

.stamp-image {
    position: absolute;
    top: -70px;
    right: -10px;
    width: 180px;
    height: auto;
    z-index: 1;
  }

.stamp-placeholder {
  font-size: 14px;
}

.report-date {
  font-size: 14px;
  margin-top: 5px;
}

.signatures {
  margin-top: 30px;
  display: flex;
  justify-content: space-around;
  font-size: 16px;
  line-height: 1.8;
  min-height: 60px;
  padding-bottom: 10px;
}

.check-table {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: 12px;
  table-layout: fixed;
  border: 1px solid #000;
  box-shadow: 0 0 0 2px #000;
}

.check-table th,
.check-table td {
  border: 1px solid #000;
  padding: 10px 8px;
  text-align: center;
  line-height: 1.6;
  background-color: transparent !important;
  word-wrap: break-word;
  overflow-wrap: break-word;
  min-height: 35px;
}

.check-table th {
  background-color: transparent !important;
  font-weight: bold;
  padding: 12px 8px;
  text-align: center;
}

.check-table .col-project {
  text-align: center !important;
  width: 12% !important;
  background-color: transparent !important;
  font-size: 13px;
}

.check-table .col-num {
  text-align: center !important;
  width: 7% !important;
  background-color: transparent !important;
  font-size: 13px;
}

.check-table .col-requirement {
  text-align: left !important;
  width: 59% !important;
  padding-left: 10px !important;
  background-color: transparent !important;
  font-size: 13px;
}

.check-table .col-result {
  text-align: center !important;
  width: 14% !important;
  background-color: transparent !important;
  font-size: 13px;
}

.check-table .col-judgment {
  text-align: center !important;
  width: 8% !important;
  background-color: transparent !important;
  font-size: 13px;
}

.check-table .judgment-pass {
  color: green;
  font-weight: bold;
  text-align: center;
}

.check-table .judgment-fail {
  color: red;
  font-weight: bold;
  text-align: center;
}

.photo-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  border: 1px solid #000;
  box-shadow: 0 0 0 2px #000;
}

.photo-table td {
  border: 1px solid #000;
  padding: 10px;
}

.photo-title {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  padding: 15px;
}

.photo-label {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: transparent;
  padding: 5px 10px;
  font-weight: bold;
  font-size: 12px;
  z-index: 1;
}

.photo-content {
  position: relative;
  height: 250px;
  text-align: center;
  vertical-align: middle;
}

.photo-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.photo-placeholder {
  line-height: 250px;
  color: #999;
  background-color: transparent;
}

@media print {
  @page {
    size: A4;
    margin: 0;
  }

  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  .security-report-preview {
    width: 100%;
    background: white;
  }

  .watermark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
    z-index: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  .page {
    width: 100%;
    min-height: auto;
    max-height: 277mm;
    padding: 8mm 12mm;
    margin: 0;
    box-shadow: none;
    page-break-after: always;
    page-break-inside: avoid;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }

  .page-1,
  .page-2,
  .page-3,
  .page-4,
  .page-5,
  .page-6 {
    z-index: 1;
  }

  .page:last-child {
    page-break-after: auto;
  }

  .cover-content,
  .page-header,
  .precautions-list,
  .precautions-en-list,
  .report-table,
  .check-table,
  .photo-table,
  .footer,
  .signatures,
  .info-section {
    position: relative;
    z-index: 2;
  }

  .report-content {
    position: relative;
  }

  .page-1,
  .page-2,
  .page-3,
  .page-4,
  .page-5,
  .page-6 {
    z-index: 1;
  }

  .report-table td,
  .check-table th,
  .check-table td,
  .photo-table td {
    border: 1px solid #000 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .stamp-image {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .photo-content img {
    max-width: 100%;
    max-height: 240px;
  }

  .check-table {
    font-size: 13px !important;
  }

  .check-table th,
  .check-table td {
    padding: 10px 8px !important;
    font-size: 13px !important;
    line-height: 1.6 !important;
    min-height: 35px !important;
  }

  .signatures {
    min-height: 50px !important;
    padding-bottom: 5px !important;
  }
}
</style>
